<template>
  <div class="LinePrice">
    <b-img-lazy center rounded  class="w-100 my-2" src="https://scontent.fbkk2-8.fna.fbcdn.net/v/t1.15752-9/274395698_4851427794966383_5448048850521627047_n.jpg?_nc_cat=103&ccb=1-5&_nc_sid=ae9488&_nc_eui2=AeEjY4PEQW0ZjzS6P2s1gqo7NcseRxtr1bw1yx5HG2vVvIj5lQnMLu9MxwbXPw7uxuM&_nc_ohc=w-i_fhOtzJgAX9ZkOMJ&_nc_ht=scontent.fbkk2-8.fna&oh=03_AVLDaoOeu-6RV1bI7cs33XiWfqoHxDcBfXWS-lh3gysrsg&oe=6255B233"></b-img-lazy>
    <b-img-lazy center rounded  class="w-100 my-2" src="https://scontent.fbkk2-4.fna.fbcdn.net/v/t1.15752-9/274490631_1876568695861956_3145246021285491120_n.jpg?_nc_cat=101&ccb=1-5&_nc_sid=ae9488&_nc_eui2=AeGizoqr90Zwsr8bDG1MFTqRQSeBH45I2FJBJ4EfjkjYUhgV09wPCIh2kOem_yY03hI&_nc_ohc=D7PSIkY0hFQAX_8OUFl&_nc_ht=scontent.fbkk2-4.fna&oh=03_AVJGdi3PvVs17thE8Kq1LL0WuP9HFDNHLQgyxiMPz9sy8g&oe=62576D4F"></b-img-lazy>
  </div>
</template>

<script>
export default {
  name: "LinePrice",
  mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
  },
  data() {
    return {
      msg: "แจ้งเตือนเท่านั้น",
      dataReady: false
    }
  },
  methods: {
    showAlert () {
      // Use sweetalert2
      this.$swal("แจ้งเตือนเท่านั้น!!!");
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/LineOA/LinePrice.vue